import { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

function WhatsApp() {
    const { isEnLang } = useLanguage();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > window.innerHeight);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const label = isEnLang ? 'CONTACT US' : 'CONTATTACI';

    return (
        <a
            href={`https://wa.me/+393928729907?text=${encodeURIComponent("Salve, vorrei informazioni sul B&B Alma Suite. www.almasuitebb.it")}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`whatsapp-btn${visible ? ' whatsapp-btn--visible' : ''}`}
            aria-label={label}
        >
            <span>{label}</span>
        </a>
    );
}

export default WhatsApp;
